import { render, staticRenderFns } from "./CadastroTerritorioInicial.vue?vue&type=template&id=39738068"
import script from "./CadastroTerritorioInicial.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioInicial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports